import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { ScreenshotName } from '../content/features';

export const SCREENSHOT_WIDTHS = [320, 480, 640] as const;

/// CSS ile çizilmiş telefon çerçevesinde uygulama ekran görüntüsü.
/// AVIF → WebP → PNG; genişlik/yükseklik belirtili (düzen kayması yok).
@Component({
  selector: 'site-phone-screenshot',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  // Eleman kendisi blok ve çerçeve genişliğinde: içerik boyutuna göre yeniden hesaplanıp
  // düzen kaydırmasın (CLS). Kural site.css'te (kritik CSS'e girer).
  host: { '[style.--phone-w]': "width() + 'px'" },
  template: `
    <div class="site-phone">
      <picture>
        <source type="image/avif" [attr.srcset]="srcset('avif')" [attr.sizes]="sizes()" />
        <source type="image/webp" [attr.srcset]="srcset('webp')" [attr.sizes]="sizes()" />
        <img
          [src]="'assets/site/screens/' + name() + '-320.png'"
          [alt]="alt()"
          width="320"
          height="693"
          decoding="async"
          [attr.loading]="priority() ? 'eager' : 'lazy'"
          [attr.fetchpriority]="priority() ? 'high' : lowPriority() ? 'low' : null"
        />
      </picture>
    </div>
  `,
})
export class PhoneScreenshotComponent {
  readonly name = input.required<ScreenshotName>();
  readonly alt = input.required<string>();
  readonly priority = input(false);
  /// Ekran dışı/ikincil görsel: ilk boyama kaynaklarıyla bant genişliği için yarışmasın.
  readonly lowPriority = input(false);
  readonly width = input(280);
  readonly sizes = computed(() => `(min-width: 768px) ${this.width()}px, 60vw`);

  srcset(format: 'avif' | 'webp'): string {
    return SCREENSHOT_WIDTHS.map((w) => `assets/site/screens/${this.name()}-${w}.${format} ${w}w`).join(', ');
  }
}
